import { gql } from 'graphql-tag';

export const CREATE_SUPPLIER = gql`
  mutation Idf93c006ae95650b85a0d36303c45cef3(
    $companyId: ID!
    $supplier: SupplierCreate!
  ) {
    __typename
  }
`;
